<div class="row ng-scope">
  <div class="col-12">


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Thời gian<span class="required">(*)</span></label>
      <div class="col-4">
        <kendo-dateinput style="width:100%;float:left" tabIndex="3" [format]="'dd/MM/yyyy HH:mm'" [(value)]="doituongSelect.Ngay"></kendo-dateinput>
      </div>
      <label class="control-label col-2 ng-binding">Số tiền<span class="required">(*)</span></label>
      <div class="col-4">
        <input class="form-control"
               maxlength="20"
               tabindex="4"
               currencyMask
               [(ngModel)]="doituongSelect.SoTien"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>




    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Nội dung</label>
      <div class="col-10">
        <textarea type="text" tabIndex="7" rows="4" class="form-control" placeholder="" [(ngModel)]="doituongSelect.NoiDung"></textarea>
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ghi chú</label>
      <div class="col-10">
        <textarea type="text" tabIndex="7" rows="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày tạo</label>
      <div class="col-10">
        <kendo-dateinput style="width:100%;float:left" tabIndex="8" [format]="'dd/MM/yyyy HH:mm:ss'" disabled="disabled" [(ngModel)]="doituongSelect.Created"></kendo-dateinput>
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Người tạo</label>
      <div class="col-10">
        <input type="text" tabIndex="8" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>





  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> Đã thu
      </label>
    </div>
  </div>
  <div class="">
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
  </div>

</div>




